<template>
    <modal
        :id="modalId"
        :title="title"
        :ok-disabled="loading"
        ok-title="Confirm"
        @ok.prevent="confirm"
        @hide="hideModal"
        @show="fetchConfirmationData"
    >
        <busy-modal :show="loading"></busy-modal>
        <div v-if="!isNil(object)" class="m-1">
            <b-row>
                <b-col md="6">
                    <b-row class="border-bottom mb-2">
                        <b-col md="12"><b>Old Package</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col xs="6">{{ object.old_package.name }}</b-col>
                        <b-col xs="6" class="text-right"
                            >{{ object.old_package.amount }} per {{ object.old_package.billing_period_string }}</b-col
                        >
                    </b-row>
                    <b-row class="border-bottom mb-2 mt-3" v-if="object.module_mapping.length > 0">
                        <b-col md="12"><b>Old Modules</b></b-col>
                    </b-row>
                    <b-row v-for="item in object.module_mapping" :key="item.id">
                        <b-col xs="6">{{ item.old_module.name }}</b-col>
                        <b-col xs="6" class="text-right"
                            >{{ item.old_module.amount }} per {{ object.old_package.billing_period_string }}</b-col
                        >
                    </b-row>
                    <b-row class="border-bottom mb-2 mt-3">
                        <b-col md="12"><b>Old Billing</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col xs="6"></b-col>
                        <b-col xs="6" class="text-right">
                            <span v-if="object.old_package.amount == '$0.00'">Free</span>
                            <span v-if="object.old_package.amount != '$0.00'"
                                >${{ object.old_price }} per {{ object.old_package.billing_period_string }}</span
                            >
                        </b-col>
                    </b-row>
                </b-col>
                <br><br>
                <b-col md="6">
                    <b-row class="border-bottom mb-2">
                        <b-col md="12"><b>New Package</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col xs="6">{{ object.new_package.name }}</b-col>
                        <b-col xs="6" class="text-right"
                            >{{ object.new_package.amount }} per {{ object.new_package.billing_period_string }}</b-col
                        >
                    </b-row>
                    <b-row class="border-bottom mb-2 mt-3" v-if="object.module_mapping.length > 0">
                        <b-col md="12"><b>New Modules</b></b-col>
                    </b-row>
                    <b-row v-for="item in object.module_mapping" :key="item.id">
                        <b-col xs="6">{{ item.new_modules[0].name }}</b-col>
                        <b-col xs="6" class="text-right"
                            >{{ item.new_modules[0].amount }} per {{ object.new_package.billing_period_string }}</b-col
                        >
                    </b-row>
                    <b-row class="border-bottom mb-2 mt-3">
                        <b-col md="12"><b>New Billing</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col xs="6"></b-col>
                        <b-col xs="6" class="text-right">
                            <span v-if="object.old_package.amount == '$0.00'">Free</span>
                            <span v-if="object.old_package.amount != '$0.00'"
                                >${{ object.new_price }} per {{ object.old_package.billing_period_string }}</span
                            >
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <br />
            <b-alert show variant="warning" v-if="object.subscription.is_trial">
                <p>During your trial period no charge will be taken for changing packages.</p>
                <p v-if="object.rooms_to_deactivate > 0">
                    Please note that you MUST deactivate or delete {{ object.rooms_to_deactivate }} of properties /
                    rooms to qualify for the downgraded subscription price.
                </p>
            </b-alert>
            <div v-if="!object.subscription.is_trial">
                <div v-if="object.mode == 'upgrade'">
                    <b-alert show variant="warning">
                        <p>
                            To upgrade your account today, you will be credited ${{ object.money_to_refund }} for
                            the previous package which was paid for earlier this month. Thus, after the credit, your
                            total remaining balance for this month is ${{ object.upgrade_price }}. Your credit card
                            will be charged immediately for ${{ object.upgrade_price }}.
                        </p>
                        <p>
                            Your next billing period (and every billing period thereafter) you will be charged the
                            full ${{ object.new_price }} per {{ object.new_package.billing_period_string }}.
                        </p>
                    </b-alert>
                </div>
                <div v-if="object.mode == 'downgrade'">
                    <b-alert show variant="warning" v-if="object.rooms_to_deactivate <= 0">
                        <p>
                            Downgrade of the package will happen on next billing date ({{
                                object.next_billing_date
                            }}). Until then you can utilize all privileges of current package.
                        </p>
                    </b-alert>
                    <b-alert show variant="warning" v-if="object.rooms_to_deactivate > 0">
                        <p>
                            Please note that you MUST deactivate or delete {{ object.rooms_to_deactivate }} of
                            properties / rooms to qualify for the downgraded subscription price.
                        </p>
                        <p>
                            This MUST occur by your next billing date of {{ object.next_billing_date }}.<br />
                            Failure to deactivate or delete the required amount of properties / rooms to qualify for
                            the downgraded subscription price will result in the downgrade request being canceled.
                        </p>
                    </b-alert>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import API from '../../../api';
    import isNil from 'lodash/isNil';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';
    import Modal from '../../generic/modal/modal.vue';
    import { formatResponseError } from '../../../utils/api';
    import {
        SUBSCRIPTION_CHANGE_PACKAGE_ENDPOINT,
        SUBSCRIPTION_CHANGE_CONFIRMATION_DATA_ENDPOINT,
    } from '../../../endpoints';

    export default {
        name: 'SubscriptionChangeConfirmationModal',
        components: {
            BusyModal,
            Modal,
        },
        props: {
            modalId: String,
            title: String,
        },
        data() {
            return {
                loading: false,
                object: null,
            };
        },
        methods: {
            isNil,
            hideModal() {
                this.$bvModal.hide(this.modalId);
            },
            async confirm() {
                this.loading = true;
                try {
                    await API.put(SUBSCRIPTION_CHANGE_PACKAGE_ENDPOINT(this.$parent.$parent.newPackageID));

                    const mode = this.object.mode == 'downgrade' ? 'downgraded' : 'upgraded';
                    this.successToast({
                        text: `Your subscription has been ${mode} to ${this.object.new_package.name}`,
                    });

                    this.$emit('success-change');

                    this.$nextTick(() => {
                        this.hideModal();
                    });
                } catch (error) {
                    const { generic } = formatResponseError(error);
                    this.errorToast({
                        text: generic || 'Something went wrong while changing subscription.',
                    });
                } finally {
                    this.loading = false;
                }
            },
            async fetchConfirmationData() {
                try {
                    this.busy = true;
                    const response = await API.get(
                        SUBSCRIPTION_CHANGE_CONFIRMATION_DATA_ENDPOINT(this.$parent.$parent.newPackageID)
                    );
                    this.object = response.data;
                    this.object = {
                        ...this.object,
                        module_mapping: this.object.module_mapping.filter(item => {
                           return item.old_module.component !== 'verification' 
                           && item.new_modules.filter(i => i.component !== 'verification').length > 0
                        }) // hide verification module
                    }
                } catch (e) {
                    this.errorToast({ text: 'Could not load subscription change confirmation data.' });
                } finally {
                    this.busy = false;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    :deep(.modal-dialog) {
        max-width: 650px !important;
        font-size: 14px !important;
    }
</style>
